export const UI_RELEASE_VERSION = process.env.REACT_APP_UI_VERSION as string;

export const GRAPH_SCOPES = {
  OPENID: 'openid',
  PROFILE: 'profile',
  USER_READ: 'User.Read',
  USER_READ_ALL: 'User.Read.All',
  USER_READ_BASIC_ALL: 'User.ReadBasic.All',
  GROUP_READ_ALL: 'Group.Read.All',
  DEFAULT: '.default',
};
export const Storage = 'https://investmentappshared.blob.core.windows.net/images/flags/4x3/ad.svg';
export const API_SCOPES = {
  API_ALL: process.env.REACT_APP_API_SCOPES_ALL as string,
  API_READ: process.env.REACT_APP_API_SCOPES_READ as string,
  API_READWRITE: process.env.REACT_APP_SCOPES_WRITE as string,
};

// For a full list of msal.js configuration parameters,
// visit https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
export const msalConfig = {
  authority: 'https://login.microsoftonline.com/86cbe1bb-213f-4271-b174-bd59d03c87a3',
  token_endpoint: 'https://login.microsoftonline.com/86cbe1bb-213f-4271-b174-bd59d03c87a3/oauth2/v2.0/token',
  clientId: process.env.REACT_APP_MSAL_CLIENTID as string,
  redirectUri: window.location.origin,
  validateAuthority: true,
  MS_GRAPH_SCOPE: 'https://graph.microsoft.com/.default',
};

// Coordinates and required scopes for your web api
export const apiConfig = {
  resourceUri: process.env.REACT_APP_API_CONFIG_RESOURCE_URI as string,
  clientId: process.env.REACT_APP_API_CONFIG_CLIENTID as string,
  authority: 'https://login.microsoftonline.com/86cbe1bb-213f-4271-b174-bd59d03c87a3',
  endPoint: process.env.REACT_APP_API_CONFIG_ENDPOINT as string,
  swaggerEndPoint: process.env.REACT_APP_API_CONFIG_SWAGGER_ENDPOINT as string,
  graphqlEndPoint: process.env.REACT_APP_API_CONFIG_GRAPHQL_ENDPOINT as string,
  signalrEndPoint: process.env.REACT_APP_API_CONFIG_SIGNALR_ENDPOINT as string,
  storageEndpoint: process.env.REACT_APP_API_CONFIG_STORAGE_ENDPOINT as string,
  scopes: [API_SCOPES.API_ALL, API_SCOPES.API_READ, API_SCOPES.API_READWRITE],
};
/**
 * Scopes you enter here will be consented once you authenticate. For a full list of available authentication parameters,
 * visit https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const loginRequest = {
  scopes: [GRAPH_SCOPES.OPENID, GRAPH_SCOPES.PROFILE, GRAPH_SCOPES.USER_READ],
};

// Add scopes here for access token to be used at Microsoft Graph API endpoints.
export const tokenRequest = {
  scopes: [GRAPH_SCOPES.OPENID, GRAPH_SCOPES.PROFILE, GRAPH_SCOPES.USER_READ],
  forceRefresh: false, // Set this to 'true' to skip a cached token and go to the server to get a new token
};
// Add scopes here for access token to be used at Microsoft Graph API endpoints.
export const tokenAppRequest = {
  scopes: [GRAPH_SCOPES.USER_READ_BASIC_ALL],
  forceRefresh: false, // Set this to 'true' to skip a cached token and go to the server to get a new token
};
export const GRAPH_ENDPOINTS = {
  ME: 'https://graph.microsoft.com/v1.0/me',
  ME_PHOTO: 'https://graph.microsoft.com/v1.0/me/photo/$value',
  MAIL: 'https://graph.microsoft.com/v1.0/me/messages',
};

export const API_ENDPOINTS = {
  GET_JSON_DATA: `${apiConfig.resourceUri}/data/json`,
  GET_REPORT: `${apiConfig.resourceUri}/report/export/xls`,
  GET_EXCEL_DAATA: `${apiConfig.resourceUri}/data/xls`,
  GET_SECURITY_PROFILE: `${apiConfig.resourceUri}/Security/getCurrentProfile`,
  GET_MAM_ACCESS_REQUEST_STATUSES: `${apiConfig.resourceUri}/Mam/getAccessRequestStatuses`,
  GET_MAM_ALL_REQUESTABLE_MARKETS_DATA: `${apiConfig.resourceUri}/Mam/getAllRequestableMarkets`,
  GET_MAM_SELF_REQUESTABLE_GROUPS_BY_COUNTRY_DATA: `${apiConfig.resourceUri}/Mam/getSelfRequestableGroupsByCountry`,
  CREATE_MAM_ACCESS_REQUEST_DATA: `${apiConfig.resourceUri}/Mam/createAccessRequest`,
  SYNC_MAM_ACCESS_REQUESTS: `${apiConfig.resourceUri}/Mam/syncAccessRequests`,
  GET_EMBED_REPORTS_DATA: `${apiConfig.resourceUri}/embedreport`,
  GET_EMBED_REPORTS_LOOKUP_DATA: `${apiConfig.resourceUri}/embedreport/lookup`,
  SET_EMBED_REPORT_KNOWLEDGE_DATA: `${apiConfig.resourceUri}/embedreport/updateKnowledgeDetails`,
  // Matches EmbedReportController's [HttpPost("embed-products/{id}/knowledge/documents")] (the
  // "saveMarkDown" action) - {id}/knowledge/documents is appended by the caller.
  SAVE_EMBED_REPORT_KNOWLEDGE_DOCUMENT_DATA: `${apiConfig.resourceUri}/embedreport/embed-products`,
  GET_MARKETS_DATA: `${apiConfig.resourceUri}/market`,
  GET_SECTIONS_DATA: `${apiConfig.resourceUri}/section`,
  GET_EMBED_TAGS_DATA: `${apiConfig.resourceUri}/embedTag`,
  GET_CONNECTIONS_DATA: `${apiConfig.resourceUri}/connection`,
  GET_EMBED_REPORT_PAGES_DATA: `${apiConfig.resourceUri}/embedreportpage`,
  GET_EMBED_REPORT_FILTERS_DATA: `${apiConfig.resourceUri}/embedreportfilter`,
  GET_POWERBI_GROUPS_DATA: `${apiConfig.resourceUri}/PowerBi/getGroups`,
  GET_POWERBI_REPORTS_DATA: `${apiConfig.resourceUri}/PowerBi`,
  GET_POWERBI_CATALOGS_DATA: `${apiConfig.resourceUri}/PowerBi`,
  GET_POWERBI_ROLES_DATA: `${apiConfig.resourceUri}/PowerBi/getRoles`,
  GET_POWERBI_SETTINGS_DATA: `${apiConfig.resourceUri}/PowerBi/getSettings`,
  GET_POWERBI_TABLES_DATA: `${apiConfig.resourceUri}/PowerBi`,
  GET_POWERBI_FIELDS_DATA: `${apiConfig.resourceUri}/PowerBi`,
  GET_POWERBI_FILTERS_DATA: `${apiConfig.resourceUri}/PowerBi/getFilterValues`,
  GET_POWERBI_FILTER_DEFAULT_DATA: `${apiConfig.resourceUri}/PowerBi`,
  GET_SECURITY_GROUPS_DATA: `${apiConfig.resourceUri}/PowerBi/getSecurityGroups`,
  CLEAN_CACHE_DATA: `${apiConfig.resourceUri}/Bulk/cleanCache`,
  PERFORM_MAINTENANCE_DATA: `${apiConfig.resourceUri}/Bulk/performMaintenance`,
  SYNCHRONIZE_BULK_DATA: `${apiConfig.resourceUri}/Bulk/synchronize`,
  AUDIT_TRAIL_DATA: `${apiConfig.resourceUri}/Bulk/auditTrail`,
  GET_REPORT_STATISTICS_DATA: `${apiConfig.resourceUri}/Report/statistics`,
  GET_AGENTS: `${apiConfig.resourceUri}/Agents`,
};

export const sendAgentMessageUrl = (agentKey: string): string => `${apiConfig.resourceUri}/Agents/${agentKey}/SendMessage`;
export const streamAgentMessageUrl = (agentKey: string): string => `${apiConfig.resourceUri}/Agents/${agentKey}/SendMessage/Stream`;

export const API_REPORTS = {
  ProductCatalog: 0,
  ProductSecurity: 2,
  ProductTrail: 1,
};

export const APP_CONFIG = {
  APPINSIGHTS_KEY: process.env.REACT_APP_APPINSIGHTS_KEY as string,
};
